/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import ChatBubble from './ChatBubble';
import ChatBubbleLoading from './ChatBubbleLoading';

const MessageBox = ({ isLoading, queryData, chatEndRef, isExpanded, sendMessage }) => {
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [queryData]);

  const handleButtonClick = (message) => {
    const formData = new FormData();
    formData.append('message', message);
    sendMessage(formData);
  };

  return (
    <div className="tw-flex tw-h-full tw-flex-col tw-overflow-auto tw-p-6 tw-pb-0">
      <ChatBubble
        isReceived
        isExpanded={isExpanded}
        message={
          <span>
            AI Tutor використовує ШІ. Взаємодіючи з ним, ви погоджуєтеся з{' '}
            <a
              className="tw-color-mainOrange"
              href="https://openai.com/uk-UA/policies/usage-policies/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b>Умовами використання</b>
            </a>{' '}
            та підтверджуєте, що ознайомилися із{' '}
            <a
              className="tw-color-mainOrange"
              href="https://prometheus.org.ua/faq/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <b>Правилами</b>
            </a>
            .
          </span>
        }
      />
      <ChatBubble isReceived message="Привіт! Як я можу допомогти?" isExpanded={isExpanded} />

      {(queryData || []).map((msg, index) => (
        <ChatBubble
          key={`${msg.message}-${index}`}
          message={msg.message}
          isReceived={msg.isReceived}
          isLoading={isLoading && index === queryData.length - 1}
          isExpanded={isExpanded}
        />
      ))}

      {isLoading && <ChatBubbleLoading />}

      <div className="tw-mt-auto tw-flex tw-flex-col tw-gap-3">
        <button
          className="tw-flex tw-w-full tw-justify-start tw-rounded-[8px] tw-bg-lighterOrange tw-px-3 tw-py-2 tw-text-[14px] tw-font-medium tw-text-[#EB7114] md:tw-justify-center"
          onClick={() => handleButtonClick('#пройдіть діагностику бізнесу')}
        >
          Пройдіть діагностику бізнесу
        </button>
        <button
          className="tw-flex tw-w-full tw-justify-start tw-rounded-[8px] tw-bg-lighterOrange tw-px-3 tw-py-2 tw-text-[14px] tw-font-medium tw-text-[#EB7114] md:tw-justify-center"
          onClick={() => handleButtonClick('#отримайте доступ до бази знань підприємця')}
        >
          Отримайте доступ до Бази знань підприємця
        </button>
      </div>

      <div ref={chatEndRef} />
    </div>
  );
};
MessageBox.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  chatEndRef: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  queryData: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string.isRequired,
      isReceived: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  sendMessage: PropTypes.func.isRequired,
};

export default MessageBox;
